<mat-card class="rounded-2xl border border-gray-6 shadow-sm h-full overflow-hidden">
  <mat-card-header class="bg-gray-1 py-4 px-6 border-b border-gray-6 flex flex-row items-center w-full">
    <div class="flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-3 text-indigo-11">
        <mat-icon>assessment</mat-icon>
      </div>
      <mat-card-title class="text-lg! font-bold! m-0! text-gray-12!">Diagnostic (DPE)</mat-card-title>
    </div>
    <div class="ml-auto flex items-center gap-2">
      @if (editable()) {
        <etxe-property-section-reminder
          [items]="missingItems()"
          [editMode]="editMode()"
          (actionClicked)="onEdit()"
        />
        <button
          mat-icon-button
          class="text-indigo-11 bg-indigo-a3 hover:bg-indigo-a4 transition-colors rounded-full"
          (click)="editMode() ? onCancel() : onEdit()"
        >
          <mat-icon>{{ editMode() ? 'close' : 'edit' }}</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        type="button"
        class="text-gray-11 hover:text-gray-12 hover:bg-gray-a3 transition-colors rounded-full"
        (click)="isExpanded.set(!isExpanded())"
        [title]="isExpanded() ? 'Replier le volet' : 'Déplier le volet'"
        [attr.aria-label]="isExpanded() ? 'Replier le volet' : 'Déplier le volet'"
      >
        <mat-icon>{{ isExpanded() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    </div>
  </mat-card-header>
  @if (isExpanded() || editMode()) {
    <mat-card-content class="p-0">
      @if (!editMode()) {
        <div class="p-6">
          <etxe-property-dpe-display [property]="property()"></etxe-property-dpe-display>
        </div>
      } @else {
        <div class="bg-gray-2 p-6">
          <etxe-property-dpe-form
            [propertyLocation]="property().location"
            [dto]="property().dpe"
            (dtoChanged)="onDtoChanged($event)"
          ></etxe-property-dpe-form>
          <div class="flex justify-end gap-3 mt-6 border-t border-gray-6 pt-4">
            <button mat-button (click)="onCancel()">Annuler</button>
            <button mat-flat-button class="primary" [disabled]="saving()" (click)="onSubmit()">
              Enregistrer
            </button>
          </div>
        </div>
      }
    </mat-card-content>
  }
</mat-card>
